import Vue from "vue";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import VueMotion from "vue-motion";

import "./plugins/axios";
import App from "./App.vue";
import router from "./router";

import CkButton from "@/components/kit/CkButton";
import CkInput from "@/components/kit/CkInput";
import CkProgressbar from "@/components/kit/CkProgressbar";
import store from "./store";

import vatValidation from "@/validators/vat";

Vue.use(VeeValidate);
Vue.use(VueMotion);

Validator.extend("vat", {
	validate: vatValidation
});

Vue.component("ck-button", CkButton);
Vue.component("ck-input", CkInput);
Vue.component("ck-progressbar", CkProgressbar);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
